<template>
  <main>
    <page-header-compact>Validación de examen de laboratorio</page-header-compact>
    <div class="container-fluid px-4">
      
      <!-- Filter Bar -->
      <div class="card card-icon mb-3 mt-3 shadow-xs">
        <div class="row no-gutters">
          <div class="col-auto card-icon-aside bg-light text-primary">
            <i class="fa fa-flask fa-fw"></i>
          </div>
          <div class="col">
            <div class="card-body py-3">
              <div class="row align-items-end">
                <div class="col-lg-4 col-md-5">
                  <label class="form-label font-weight-bold text-gray-700 mb-1 small">Fecha</label>
                  <input
                    v-model="fecha"
                    
                    class="form-control form-control-sm"
                    type="date"
                  />
                </div>
                <div class="col-lg-5 col-md-5 mt-2 mt-md-0">
                  <label class="form-label font-weight-bold text-gray-700 mb-1 small">Documento Paciente</label>
                  <input
                    v-model="pagination.search"
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Ingrese documento o nombre del paciente..."
                    @keyup.enter="cargarResultadosExamenes()"
                  />
                </div>
                <div class="col-lg-3 col-md-2 mt-3 mt-md-0">
                  <button class="btn btn-primary btn-sm font-weight-bold btn-block" @click="cargarResultadosExamenes()">
                    <i class="fa fa-search fa-fw mr-1"></i> Buscar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pagination.data && pagination.data.length === 0" class="alert alert-warning  shadow-sm">
        <i class="fas fa-exclamation-circle mr-2"></i> No se encontraron resultados de laboratorio para los criterios seleccionados...
      </div>

      <!-- DataGrid List -->
      <div class="card shadow-none border-0">
        <div class="card-body">
          <data-grid
            :data="pagination"
            :search-box="false"
            @search="search($event)"
          >
            <template #grid>
              
             

              <!-- Main Orders Loop -->
              <div v-for="item in pagination.data" :key="item.id" class="mb-4">
                
                <!-- Patient Info Header -->
                <div class="card card-icon mb-2 shadow-none border border-left-lg border-left-primary">
                  <div class="row no-gutters align-items-center">
                    <div v-if="item.orden_trabajo && item.orden_trabajo.usuario && item.orden_trabajo.usuario.sexo === 'F'" class="text-center col-auto card-icon-aside bg-light">
                      <img src="@/assets/img-genero/mujer.png" width="70">
                    </div>
                    <div v-else-if="item.orden_trabajo && item.orden_trabajo.usuario && item.orden_trabajo.usuario.sexo === 'M'" class="text-center col-auto card-icon-aside bg-light">
                      <img src="@/assets/img-genero/hombre.png" width="55">
                    </div>
                    <div class="col">
                      <div class="card-body py-2">
                        <div class="row align-items-center">
                          <div class="col-md-7">
                            <h5 class="mb-1 font-weight-bold text-dark" v-if="item.orden_trabajo && item.orden_trabajo.usuario">
                              {{ item.orden_trabajo.usuario.nombre_1 }} {{ item.orden_trabajo.usuario.nombre_2 }}
                              {{ item.orden_trabajo.usuario.apellido_1 }} {{ item.orden_trabajo.usuario.apellido_2 }}
                            </h5>
                            <div class="small text-muted" v-if="item.orden_trabajo && item.orden_trabajo.usuario">
                              Identificación: <strong class="text-dark">{{ item.orden_trabajo.usuario.documento }}</strong> | 
                              Edad: <strong class="text-dark">{{ item.orden_trabajo.usuario.years }} años</strong>
                            </div>
                          </div>
                          <div class="col-md-5 text-md-right mt-2 mt-md-0">
                            <span class="badge badge-light border text-gray-700 px-3 py-2 font-weight-bold">
                              <i class="fas fa-file-invoice mr-1 text-muted"></i> Orden No: {{ item.orden_trabajo ? item.orden_trabajo.id : item.id }}
                            </span>
                             <span class="badge badge-primary-soft text-primary px-3 py-2 ml-2 font-weight-bold">
                              <i class="far fa-calendar-alt mr-1"></i> {{ item.fecha | formatDate }}
                            </span>
                             <span class="badge badge-light text-bold px-3 py-2 ml-2 mt-2 font-weight-bold" v-if="item.orden_trabajo">
                              <i class="fas fa-result mr-1"></i> Muestra No: {{ item.orden_trabajo.toma_muestra }}
                            </span>
                            <span class="badge badge-light text-bold px-3 py-2 ml-2 mt-2 font-weight-bold" v-if="item.orden_trabajo && item.orden_trabajo.sede">
                              <i class="fas fa-building mr-1"></i> {{ item.orden_trabajo.sede.NOMBRE_SEDE  }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- AREAS & EXAMS TABS -->
                <div class="card shadow-none mt-2">
                  <div class="card-header border-bottom">
                    <ul class="nav nav-tabs card-header-tabs" :id="`pills-tab-${item.id}`" role="tablist">
                      <li v-for="(area, i) in getGroupedAreas(item)" :key="area.id" class="nav-item">
                        <a
                          :id="`nav_${item.id}_${area.id}`"
                          :class="{ active: i === 0 }"
                          :href="`#tab_${item.id}_${area.id}`"
                          class="nav-link text-uppercase font-weight-bold small px-3 mr-2"
                          data-toggle="tab"
                          role="tab"
                        >
                          {{ area.nombre }}
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div class="card-body">
                    <div class="tab-content" :id="`nav-tabContent-${item.id}`">
                      <div
                        v-for="(area, i) in getGroupedAreas(item)"
                        :id="`tab_${item.id}_${area.id}`"
                        :key="`tab_${item.id}_${area.id}`"
                        :class="{ 'show active': i === 0 }"
                        class="tab-pane fade"
                        role="tabpanel"
                      >
                        <!-- Table Header -->
                        <div class="card-header bg-gray-100">
                          <div class="row align-items-center no-gutters text-uppercase font-weight-bold text-gray-600" style="font-size: 0.7rem; letter-spacing: 0.05em;">
                            <div class="col-lg-3">Determinación</div>
                            <div class="col-lg-3 text-center">Resultado</div>
                            <div class="col-lg-3 text-center">Valores Referencia</div>
                            <div class="col-lg-3 text-right pr-3">Estado / Validación</div>
                          </div>
                        </div>

                        <!-- EXAM LIST WITHIN AREA -->
                        <div class="list-group p-2">
                          <div v-for="(entry, index) in area.items" :key="index">
                            
                            <!-- CASE: GROUP (Examen Padre) -->
                            <template v-if="entry.type === 'group'">
                              <div class="bg-gray-200 px-3 py-2 border-bottom text-xs font-weight-bold text-dark small text-uppercase">
                                <i class="fas fa-list-ul text-primary mr-2"></i> {{ entry.nombre }}
                              </div>

                              <div v-for="detalle in entry.items" :key="detalle.id" class="list-group-item px-3 py-1 border-bottom border-light">
                                <div class="row align-items-center no-gutters">
                                  <div class="col-lg-3 pl-3 text-sm">
                                    <span class="font-weight-bold text-gray-700">{{ detalle.examenes ? detalle.examenes.nombre : 'Examen' }}</span>
                                  </div>
                                  <div class="col-lg-3">
                                    <texto v-if="detalle.examenes && detalle.examenes.tipo === 'texto'" v-model="detalle.resultado" :validado="detalle.validado"></texto>
                                    <numerico v-if="detalle.examenes && detalle.examenes.tipo === 'numero'" v-model="detalle.resultado" :validado="detalle.validado"></numerico>
                                    <opciones v-if="detalle.examenes && detalle.examenes.tipo === 'opcion'" v-model="detalle.resultado" :examen="detalle.examenes" :validado="detalle.validado"></opciones>
                                  </div>
                                  <div class="col-lg-3 text-center">
                                    <div v-if="detalle.examenes && (detalle.examenes.valores_referencia || detalle.examenes.unidad)" class="ref-value-box text-gray-600 font-weight-bold px-1 py-1" style="font-size: 0.75rem;">
                                      {{ detalle.examenes.valores_referencia }} <small class="ml-1">{{ detalle.examenes.unidad }}</small>
                                    </div>
                                    <span v-else class="text-muted small italic">N/A</span>
                                  </div>
                                  <div class="col-lg-3 text-right pr-3">
                                    <div v-if="detalle.validado === 0">
                                      <span class="badge badge-warning text-dark mr-2">Sin validar</span>
                                      <button class="btn btn-success btn-xs shadow-sm font-weight-bold" @click="validarExamen(detalle)">
                                        <i class="fa fa-check fa-fw mr-1"></i>Validar
                                      </button>
                                    </div>
                                    <div v-else>
                                      <span class="badge badge-success px-3 py-1 font-weight-bold">
                                        <i class="fas fa-check-circle mr-1"></i> Validado
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>

                            <!-- CASE: STANDALONE (Examen Independiente) -->
                            <div v-else class="list-group-item px-3 py-1 border-bottom border-light">
                              <div class="row align-items-center no-gutters">
                                <div class="col-lg-3">
                                  <span class="font-weight-bold text-dark text-sm">{{ entry.examenes ? entry.examenes.nombre : 'Examen' }}</span>
                                </div>
                                <div class="col-lg-3">
                                  <texto v-if="entry.examenes && entry.examenes.tipo === 'texto'" v-model="entry.resultado" :validado="entry.validado"></texto>
                                  <numerico v-if="entry.examenes && entry.examenes.tipo === 'numero'" v-model="entry.resultado" :validado="entry.validado"></numerico>
                                  <opciones v-if="entry.examenes && entry.examenes.tipo === 'opcion'" v-model="entry.resultado" :examen="entry.examenes" :validado="entry.validado"></opciones>
                                </div>
                                <div class="col-lg-3 text-center">
                                  <div v-if="entry.examenes && (entry.examenes.valores_referencia || entry.examenes.unidad)" class="ref-value-box text-gray-600 font-weight-bold px-1 py-1" style="font-size: 0.75rem;">
                                    {{ entry.examenes.valores_referencia }} <small class="ml-1">{{ entry.examenes.unidad }}</small>
                                  </div>
                                  <span v-else class="text-muted small italic">N/A</span>
                                </div>
                                <div class="col-lg-3 text-right pr-3">
                                  <div v-if="entry.validado === 0">
                                    <span class="badge badge-warning text-dark mr-2">Sin validar</span>
                                    <button class="btn btn-success btn-xs shadow-sm font-weight-bold" @click="validarExamen(entry)">
                                      <i class="fa fa-check fa-fw mr-1"></i>Validar
                                    </button>
                                  </div>
                                  <div v-else>
                                    <span class="badge badge-success px-3 py-1 font-weight-bold">
                                      <i class="fas fa-check-circle mr-1"></i> Validado
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </template>
          </data-grid>
        </div>
      </div>

    </div>
  </main>
</template>

<script>
import PageHeaderCompact from "../../../../../components/layouts/content/page-header-compact";
import resultadosLaboratorioService from "../../../../../services/resultadosLaboratorioService";
import Toast from "../../../../../components/common/utilities/toast";
import DataGrid from "../../../../../components/common/utilities/DataGrid/DataGrid";
import paginateMixin from "../../../../../mixins/PaginateMixin";
import texto from "../../../../../views/historias/base/resultadosLaboratorios/tipos/texto";
import numerico from "../../../../../views/historias/base/resultadosLaboratorios/tipos/numerico";
import opciones from "../../../../../views/historias/base/resultadosLaboratorios/tipos/opciones";

export default {
  components: {
    PageHeaderCompact,
    DataGrid,
    texto,
    numerico,
    opciones,
  },
  mixins: [
    paginateMixin(async (search = "", pagination = {}) =>
      resultadosLaboratorioService.index(search, pagination)
    ),
  ],
  data() {
    return {
      Isdisabled: false,
      resultadosExamenes: [],
      fecha: "",
      id_profesional: "",
      pagination: {
        per_page: 1,
        params: {
          id_profesional: "",
          fecha: "",
        },
      },
    };
  },
  watch: {
    "pagination.data": {
      handler: function () {
        this.calcularMicroalbuminuriaCreatinina();
      },
      deep: true,
    },
  },

  methods: {
    calcularMicroalbuminuriaCreatinina() {
      if (!this.pagination.data || !this.pagination.data.length) return;

      this.pagination.data.forEach(order => {
        if (!order.detalles || !order.detalles.length) return;

        let malb = null;
        let crea = null;
        let targetItem = null;

        order.detalles.forEach(detalle => {
          const abbr = detalle.examenes ? detalle.examenes.abbr_name : '';
          if (abbr === 'mALB-O') {
            malb = detalle;
          } else if (abbr === 'CREA-O') {
            crea = detalle;
          } else if (abbr === 'mALB-CR') {
            targetItem = detalle;
          }
        });

        if (malb && crea && targetItem) {
          const valMalb = parseFloat(malb.resultado);
          const valCrea = parseFloat(crea.resultado);

          if (!isNaN(valMalb) && !isNaN(valCrea) && valCrea !== 0) {
            const calculated = ((valMalb / valCrea) * 100).toFixed(2);
            if (targetItem.resultado !== calculated) {
              targetItem.resultado = calculated;
            }
          } else {
            if (targetItem.resultado !== '') {
              targetItem.resultado = '';
            }
          }
        }
      });
    },
    /**
     * Agrupa los detalles de resultados de un orden de trabajo por Área y Examen Padre.
     */
    getGroupedAreas(item) {
      if (!item || !item.detalles || !item.detalles.length) {
        return [];
      }

      let areasMap = {};

      item.detalles.forEach((detalle) => {
        if (!detalle.examenes) return;

        const ex = detalle.examenes;
        const area = ex.area || { id: ex.id_area || 0, nombre: "Área General" };
        const areaId = area.id || 0;

        if (!areasMap[areaId]) {
          areasMap[areaId] = {
            id: areaId,
            nombre: area.nombre || "Área General",
            items: [],
          };
        }

        // Buscar id_examen padre y nombre del examen padre
        const idPadre = ex.id_examen;
        const parentName =
          (ex.examen_padre ? ex.examen_padre.nombre : null) ||
          (ex.padre ? ex.padre.nombre : null) ||
          (ex.examen ? ex.examen.nombre : null);

        if (idPadre && idPadre !== ex.id && parentName) {
          let group = areasMap[areaId].items.find(
            (x) => x.type === "group" && x.id === idPadre
          );

          if (!group) {
            group = {
              type: "group",
              id: idPadre,
              nombre: parentName,
              orden: (ex.examen_padre ? ex.examen_padre.orden : null) ||
                     (ex.padre ? ex.padre.orden : null) ||
                     (ex.examen ? ex.examen.orden : null),
              items: [],
            };
            areasMap[areaId].items.push(group);
          }
          group.items.push(detalle);
        } else {
          // Examen independiente / standalone
          detalle.type = "item";
          areasMap[areaId].items.push(detalle);
        }
      });

      Object.keys(areasMap).forEach((areaId) => {
        // 1. Sort the items within each group
        areasMap[areaId].items.forEach((item) => {
          if (item.type === "group" && item.items) {
            item.items.sort((a, b) => {
              const oA = (a.examenes && a.examenes.orden !== null && a.examenes.orden !== undefined && a.examenes.orden !== "") ? parseInt(a.examenes.orden) : Infinity;
              const oB = (b.examenes && b.examenes.orden !== null && b.examenes.orden !== undefined && b.examenes.orden !== "") ? parseInt(b.examenes.orden) : Infinity;
              return oA - oB;
            });
          }
        });

        // 2. Sort the top-level items of the area (standalone and groups)
        areasMap[areaId].items.sort((a, b) => {
          const getOrdenVal = (node) => {
            if (node.type === "group") {
              if (node.orden !== undefined && node.orden !== null && node.orden !== "") return parseInt(node.orden);
              if (node.items && node.items.length) {
                const firstItem = node.items[0];
                if (firstItem.examenes && firstItem.examenes.examen_padre && firstItem.examenes.examen_padre.orden !== undefined && firstItem.examenes.examen_padre.orden !== null) {
                  return parseInt(firstItem.examenes.examen_padre.orden);
                }
              }
              return Infinity;
            }
            const val = node.examenes ? node.examenes.orden : null;
            return (val !== undefined && val !== null && val !== "") ? parseInt(val) : Infinity;
          };

          return getOrdenVal(a) - getOrdenVal(b);
        });
      });

      return Object.values(areasMap);
    },

    async cargarResultadosExamenes() {
      try {
        

        this.LoaderSpinnerShow();

        this.pagination.params.fecha = this.fecha;
        this.pagination.params.id_profesional = this.id_profesional;
        const response = await resultadosLaboratorioService.index(
          this.pagination.search,
          this.pagination
        );
        this.resultadosExamenes = response.data;
        this.pagination.data = response.data.data;
        this.pagination.current_page = response.data.current_page;
        this.pagination.total = response.data.total;
        this.LoaderSpinnerHide();
      } catch (error) {
        console.log(error);
        this.LoaderSpinnerHide();
        Toast.fire({
          icon: "error",
          title: "Ha ocurrido un error al procesar la solicitud",
        });
      }
    },

    async validarExamen(detalle) {
      try {
        await resultadosLaboratorioService.cambiarEstado(
          detalle.id,
          detalle.resultado
        );
        detalle.validado = 1;
        Toast.fire({
          icon: "success",
          title: "Examen validado con éxito",
        });
      } catch (error) {
        console.error(error);
        Toast.fire({
          icon: "error",
          title: "Ha ocurrido un error al validar el examen",
        });
      }
    },
  },
};
</script>

<style scoped>
.ref-value-box {
  background-color: #f1f5f9;
  border-radius: 4px;
  display: inline-block;
  max-width: 100%;
  white-space: normal;
  word-wrap: break-word;
  text-align: right;
  line-height: 1.2;
}

.bg-gray-100 {
  background-color: #f1f5f9 !important;
}

.bg-gray-200 {
  background-color: #eaecf4 !important;
}

.badge-primary-soft {
  background-color: rgba(78, 115, 223, 0.1);
  color: #4e73df;
}

.badge-info-soft {
  background-color: rgba(54, 185, 204, 0.1);
  color: #36b9cc;
}

.border-left-primary {
  border-left: 0.25rem solid #4e73df !important;
}
</style>
